frappe.provide("frappe.views");

const DEFAULT_FIELD_MAP = {
	start: "start",
	end: "end",
	id: "name",
	progress: "progress",
	color: "color",
	is_milestone: "is_milestone",
	depends_on: "depends_on_tasks",
};

frappe.views.GanttView = class GanttView extends frappe.views.ListView {
	get view_name() {
		// __("Gantt")
		return "Gantt";
	}

	setup_defaults() {
		return super.setup_defaults().then(() => {
			this.page_title = this.page_title + " " + __("Gantt");
			this.calendar_settings = frappe.views.calendar[this.doctype] || {};
			this.calendar_settings.field_map = {
				...DEFAULT_FIELD_MAP,
				...(this.calendar_settings.field_map || {}),
			};

			if (typeof this.calendar_settings.gantt == "object") {
				Object.assign(this.calendar_settings, this.calendar_settings.gantt);
			}

			if (this.calendar_settings.order_by) {
				this.sort_by = this.calendar_settings.order_by;
				this.sort_order = "asc";
			} else {
				this.sort_by =
					this.view_user_settings.sort_by || this.calendar_settings.field_map.start;
				this.sort_order = this.view_user_settings.sort_order || "asc";
			}
		});
	}

	setup_view() {}

	set_result_height() {
		// @dokos: constrain the gantt result area so the paging bar stays pinned at the bottom
		if (frappe.is_mobile()) return;
		const pagingHeight = this.$paging_area.get(0).offsetHeight;
		const resultTop = this.$result.get(0).offsetTop;
		const height = window.innerHeight - pagingHeight - resultTop;
		this.$result.css({ height: height + "px", overflow: "auto" });
	}

	get_fields() {
		// Add necessary fields for Gantt
		let fields = super.get_fields();
		const field_map = this.calendar_settings.field_map || DEFAULT_FIELD_MAP;
		const meta = this.meta;

		const gantt_fields = [
			field_map.start,
			field_map.end,
			field_map.progress,
			field_map.id,
			field_map.title,
			field_map.color,
			field_map.is_milestone,
			field_map.depends_on,
		].filter((f) => typeof f === "string");
		gantt_fields.forEach((fieldname) => {
			let full_fieldname = frappe.model.get_full_column_name(fieldname, this.doctype);
			if (
				!fields.includes(full_fieldname) &&
				meta.fields.find((f) => f.fieldname === fieldname)
			) {
				fields.push(full_fieldname);
			}
		});
		return fields;
	}

	prepare_data(data) {
		super.prepare_data(data);
		this.prepare_tasks();
	}

	prepare_tasks() {
		var me = this;
		var meta = this.meta;
		let field_map = this.calendar_settings.field_map || DEFAULT_FIELD_MAP;

		if (!this.data[0]?.[field_map.progress]) {
			this.progress_disabled = true;
		}

		if (!this.meta.fields.find((k) => k.fieldname === field_map.start)) {
			frappe.msgprint({
				title: __("Incorrect configuration"),
				message: __(
					"Please configure the start field for this Doctype in the controller file."
				),
				indicator: "red",
			});
		}
		this.tasks = this.data.map(function (item) {
			// set progress
			var progress = 0;
			if (typeof field_map.progress === "function") {
				progress = field_map.progress(item);
			} else if (field_map.progress) {
				progress = item[field_map.progress];
			}

			// title
			let label;
			if (field_map.title) {
				label = item[field_map.title];
			} else if (meta.title_field) {
				label = item.progress
					? __("{0} ({1}) - {2}%", [item[meta.title_field], item.name, item.progress])
					: __("{0} ({1})", [item[meta.title_field], item.name]);
			} else {
				label = item["name"];
			}

			const r = {
				start: item[field_map.start],
				end: item[field_map.end] || item[field_map.start],
				name: label,
				id: item[field_map.id],
				doctype: me.doctype,
				progress: progress,
				dependencies: "",
			};

			if (field_map.depends_on) {
				r.dependencies = item[field_map.depends_on] || "";
			}
			if (
				field_map.color &&
				item[field_map.color] &&
				frappe.ui.color.validate_hex(item[field_map.color])
			) {
				r["custom_class"] = "color-" + item[field_map.color].substr(1);
			}
			if (field_map.is_milestone && item[field_map.is_milestone]) {
				r["custom_class"] = "bar-milestone";
			}

			return r;
		});
	}

	render() {
		this.load_lib.then(() => {
			this.render_gantt();
		});
	}

	render_header() {}

	render_gantt() {
		const me = this;
		const gantt_view_mode = this.view_user_settings.gantt_view_mode || "Day";
		const field_map = this.calendar_settings.field_map;
		const date_format = "YYYY-MM-DD";

		const pagingHeight = this.$paging_area.get(0).offsetHeight; // @dokos
		const resultTop = this.$result.get(0).offsetTop; // @dokos
		const height = window.innerHeight - pagingHeight - resultTop; // @dokos

		this.$result.empty();
		this.gantt = new Gantt(this.$result[0], this.tasks, {
			bar_height: 35,
			bar_corner_radius: 4,
			hover_on_date: true,
			view_mode: gantt_view_mode,
			date_format: "YYYY-MM-DD",
			readonly: !me.can_write,
			readonly_progress: this.progress_disabled,
			fixed_duration: field_map.start === field_map.end,
			language: frappe.boot.lang,
			container_height: height, // @dokos
			on_double_click: (task) => {
				frappe.set_route("Form", task.doctype, task.id);
			},
			on_date_click: (date) => {
				console.log(date);
				if (date) frappe.new_doc("ToDo", { date: new Date(date) });
			},
			on_date_change: (task, start, end) => {
				if (!me.can_write) return;
				frappe.db.set_value(task.doctype, task.id, {
					[field_map.start]: moment(start).format(date_format),
					[field_map.end]: moment(end).format(date_format),
				});
			},
			on_progress_change: (task, progress) => {
				if (!me.can_write) return;
				let progress_fieldname;

				if (typeof field_map.progress === "function") {
					progress_fieldname = null;
				} else if (field_map.progress && task[field_map.progress]) {
					progress_fieldname = field_map.progress;
				}

				if (progress_fieldname) {
					frappe.db.set_value(task.doctype, task.id, {
						[progress_fieldname]: parseInt(progress),
					});
				}
			},
			on_view_change: (mode) => {
				// save view mode
				me.save_view_user_settings({
					gantt_view_mode: mode.name,
				});
			},
			popup: ({ task }) => {
				var item = me.get_item(task.id);
				var html = `<div class="title">${task.name}</div>
					<div class="subtitle">${moment(task.start).format("MMM D")} - ${moment(task.end).format(
					"MMM D"
				)}</div>`;

				// custom html in doctype settings
				var custom = me.settings.gantt_custom_popup_html;
				if (custom && $.isFunction(custom)) {
					var ganttobj = task;
					html = custom(ganttobj, item);
				}
				return '<div class="details-container">' + html + "</div>";
			},
		});

		const todayButton = this.gantt.$today_button; // @dokos

		if (todayButton) {
			todayButton.textContent = __("Today"); // @dokos
			todayButton.classList.add("btn");
			todayButton.classList.add("btn-default");
		}
		this.setup_view_mode_buttons();
		this.set_colors();
	}

	setup_view_mode_buttons() {
		// view modes (for translation) __("Day"), __("Week"), __("Month"),
		//__("Half Day"), __("Quarter Day")

		if (this.$paging_area.find(".gantt-view-mode").length > 0) return;

		const view_modes = this.gantt.options.view_modes || [];
		const active = view_modes.find((mode) => this.gantt.view_is(mode.name));
		const view_mode_group = new frappe.ui.TabButtons({
			label: __("Gantt View Mode"),
			css_class: "gantt-view-mode ms-2 me-2",
			options: view_modes.map((mode) => ({
				label: __(mode.name),
				value: mode.name,
			})),
			value: active && active.name,
			// change view mode asynchronously
			on_change: (value) => setTimeout(() => this.gantt.change_view_mode(value), 0),
		});
		this.$paging_area.find(".level-left").append(view_mode_group.$el);
	}

	set_colors() {
		const classes = this.tasks
			.map((t) => t.custom_class)
			.filter((c) => c && c.startsWith("color-"));

		let style = classes
			.map((c) => {
				const class_name = c.replace("#", "");
				const bar_color = "#" + c.substr(6);
				const progress_color = frappe.ui.color.get_contrast_color(bar_color);
				return `
				.gantt .bar-wrapper.${class_name} .bar {
					fill: ${bar_color};
				}
				.gantt .bar-wrapper.${class_name} .bar-progress {
					fill: ${progress_color};
				}
			`;
			})
			.join("");

		style = `<style>${style}</style>`;
		this.$result.prepend(style);
	}

	get_item(name) {
		return this.data.find((item) => item.name === name);
	}

	get required_libs() {
		return [
			"assets/frappe/node_modules/frappe-gantt/dist/frappe-gantt.css",
			"assets/frappe/node_modules/frappe-gantt/dist/frappe-gantt.umd.js",
		];
	}
};
